import { FeatureDevice } from "../_00Global/FeatureDevice";
import { MusicNote01 } from "./icons/MusicNote01";
import { Swapicon } from "./icons/Swapicon";
import { Swapicon1 } from "./icons/Swapicon1";
import { Swapicon3 } from "./icons/Swapicon3";
import { Swapicon4 } from "./icons/Swapicon4";
import { Swapicon5 } from "./icons/Swapicon5";

interface Props {
  featureDeviceIcon?: JSX.Element;
  override?: JSX.Element;
  featureDeviceIcon1?: JSX.Element;
  featureDeviceIcon2?: JSX.Element;
  featureDeviceIcon3?: JSX.Element;
  featureDeviceIcon4?: JSX.Element;
}

export const _02BBody = ({
  featureDeviceIcon = (
    <Swapicon className="!relative !w-[41px] !h-[41px] !ml-[-10.00px] !mr-[-10.00px]" />
  ),
  override = (
    <Swapicon1 className="!relative !w-[41px] !h-[41px] !ml-[-10.00px] !mr-[-10.00px]" />
  ),
  featureDeviceIcon1 = (
    <MusicNote01
      className="!relative !w-[41px] !h-[41px] !ml-[-10.00px] !mr-[-10.00px]"
      color="#657D84"
    />
  ),
  featureDeviceIcon2 = (
    <Swapicon3 className="!relative !w-[41px] !h-[41px] !ml-[-10.00px] !mr-[-10.00px]" />
  ),
  featureDeviceIcon3 = (
    <Swapicon4 className="!relative !w-[41px] !h-[41px] !ml-[-10.00px] !mr-[-10.00px]" />
  ),
  featureDeviceIcon4 = (
    <Swapicon5 className="!relative !w-[41px] !h-[41px] !ml-[-10.00px] !mr-[-10.00px]" />
  ),
}: Props): JSX.Element => {
  return (
    <div className="flex justify-center w-full">
      <div className="w-full max-w-[1440px] flex flex-col items-center justify-center min-h-[750px] relative">
        <div className="w-full max-w-[1100px] px-4">
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-y-10 gap-x-10 lg:gap-[70px_100px] py-[30px] justify-items-center mx-auto max-w-[750px] lg:max-w-none">
            <FeatureDevice
              featureCardDescription="No formal poses. We're candid. You won't even know we're there!"
              featureCardTitle="Natural Style"
              icon={featureDeviceIcon}
            />
            <FeatureDevice
              featureCardDescription="Split the cost for FREE, up to 3 months after your Wedding date."
              featureCardTitle="Pay Monthly"
              icon={override}
            />
            <FeatureDevice
              featureCardDescription="From Beethoven to Beyonce. Our licence covers everything."
              featureCardTitle="Choose Music"
              icon={featureDeviceIcon1}
            />
            <FeatureDevice
              featureCardDescription="Dedicated camera so guests can leave you a future video message."
              featureCardTitle="Interviews"
              icon={featureDeviceIcon2}
            />
            <FeatureDevice
              featureCardDescription="Singing Waiters, Special Performers, Marryoke, Surprises, we cover it all."
              featureCardTitle="Performances"
              icon={featureDeviceIcon3}
            />
            <FeatureDevice
              featureCardDescription="Watch on your TV, Laptop & Phone, anywhere, anytime, forever!"
              featureCardTitle="Online Gallery"
              icon={featureDeviceIcon4}
            />
          </div>
        </div>
      </div>
    </div>
  );
}; 